/* eslint-disable max-len */
import React from 'react';

export const ColorIcon = props => (
  <svg width="40px" height="40px" viewBox="0 0 40 40" {...props}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-49.000000, -242.000000)">
        <g transform="translate(49.000000, 242.000000)">
          <g>
            <g>
              <rect stroke="currentColor" x="0.5" y="0.5" width="39" height="39" rx="1" />
            </g>
            <g transform="translate(6.000000, 6.000000)">
              <rect stroke="currentColor" x="0.5" y="0.5" width="27" height="27" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
